import { GameResult as GameResultEnum } from '@/models/games/roulette/GameResult';
import { isBitActive } from '@/utils/bitwiseUtil';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { useMemo } from 'react';
import { GameResultCellProps } from '..';

export const RouletteGameResult = (props: GameResultCellProps) => {
    const { summary } = props;

    const color = useMemo(() => {
        if (isBitActive(summary.WinSlot, GameResultEnum.RRZero)) {
            return '#FF4F4F';
        } else if (isBitActive(summary.WinSlot, GameResultEnum.RRRed)) {
            return '#c70000';
        } else if (isBitActive(summary.WinSlot, GameResultEnum.RRBlack)) {
            return '#6C6C6C';
        }
    }, [summary.WinSlot]);

    return (
        <>
            <Stack className="item-roulette-game-result-container">
                <Box bgcolor={color} className="result-container">
                    {summary.Result}
                </Box>
            </Stack>
        </>
    );
};
